/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ScraperJobConfigurationFragmentDoc } from './ScraperJobConfigurationFragment'
import { ScraperJobConfigurationHistoryFragmentDoc } from './ScraperJobConfigurationHistoryFragment'
export type IScraperJobConfigurationAndHistoryFragment = {
  __typename?: 'ScraperJobConfigurationAndHistory'
} & {
  updatedScraperJobConfiguration?: Types.Maybe<
    { __typename?: 'ScraperJobConfiguration' } & Pick<
      Types.IScraperJobConfiguration,
      | 'id'
      | 'jobUuid'
      | 'shipperApplicationId'
      | 'tmsName'
      | 'jobType'
      | 'jobSubtype'
      | 'description'
      | 'isEnabled'
      | 'demoMode'
      | 'elementsWaitingTime'
      | 'comment'
      | 'deprecatedAt'
      | 'jobQueueName'
    > & {
        shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
          Types.IShipperApplication,
          'id' | 'name'
        >
        updatedBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'firstName' | 'lastName'>
        scraperJobExecutionLastExecution?: Types.Maybe<
          { __typename?: 'ScraperJobExecutionHistory' } & Pick<
            Types.IScraperJobExecutionHistory,
            | 'id'
            | 'scraperJobConfigurationId'
            | 'startedAt'
            | 'endedAt'
            | 'result'
            | 'errorType'
            | 'errorMessage'
          >
        >
        scraperJobExecutionCurrentExecution?: Types.Maybe<
          { __typename?: 'ScraperJobExecutionHistory' } & Pick<
            Types.IScraperJobExecutionHistory,
            | 'id'
            | 'scraperJobConfigurationId'
            | 'startedAt'
            | 'endedAt'
            | 'result'
            | 'errorType'
            | 'errorMessage'
          >
        >
      }
  >
  updatedScraperJobConfigurationHistory?: Types.Maybe<
    { __typename?: 'ScraperJobConfigurationHistory' } & {
      scraperConfigurationHistory: Array<
        { __typename?: 'ScraperJobConfigurationHistoryItem' } & Pick<
          Types.IScraperJobConfigurationHistoryItem,
          'desc' | 'updatedAt'
        > & {
            updatedBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'firstName' | 'lastName'>
          }
      >
    }
  >
}

export const ScraperJobConfigurationAndHistoryFragmentDoc = gql`
  fragment ScraperJobConfigurationAndHistory on ScraperJobConfigurationAndHistory {
    updatedScraperJobConfiguration {
      ...ScraperJobConfiguration
    }
    updatedScraperJobConfigurationHistory {
      ...ScraperJobConfigurationHistory
    }
  }
  ${ScraperJobConfigurationFragmentDoc}
  ${ScraperJobConfigurationHistoryFragmentDoc}
`
